import { render, staticRenderFns } from "./DynamicFormDashboard.vue?vue&type=template&id=22972562&scoped=true&"
import script from "./DynamicFormDashboard.vue?vue&type=script&lang=js&"
export * from "./DynamicFormDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormDashboard.vue?vue&type=style&index=0&id=22972562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22972562",
  null
  
)

export default component.exports